import { Toaster as Sonner } from "sonner";
import { CircleCheck, CircleX, Info } from "lucide-react";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      position="top-right"
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheck className="w-5 h-5 text-turquoise" />,
        error: <CircleX className="w-5 h-5 text-status-error" />,
        info: <Info className="w-5 h-5 text-turquoise" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white/95 group-[.toaster]:backdrop-blur-md group-[.toaster]:text-navy group-[.toaster]:border group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-turquoise group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success:
            "group-[.toaster]:!border-turquoise/40 group-[.toaster]:!text-navy",
          error:
            "group-[.toaster]:!border-status-error/40 group-[.toaster]:!text-navy",
          info:
            "group-[.toaster]:!border-turquoise/40 group-[.toaster]:!text-navy",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
